module.exports = __webpack_public_path__ + "static/media/arrowUp.cc8a92a7.svg";